export default __webpack_public_path__ + "static/media/add-circle.4ac32ec3.svg";